import { setConnectionIsCorrect, setShowConnectionIndicator } from './actions';
import {
    SET_SHOW_CONNECTION_INDICATOR,
    SET_WARN_ON_MOBILE_DATA,
} from './constants';
import { ConnectionReduxState } from './types';

const initialState: ConnectionReduxState = {
    showConnectionIndicator: false,
    warnOnMobileData: false,
};

const handlers = {
    [SET_SHOW_CONNECTION_INDICATOR](
        state: ConnectionReduxState,
        { payload: { show } }: ReturnType<typeof setShowConnectionIndicator>,
    ): ConnectionReduxState {
        return {
            ...state,
            showConnectionIndicator: show,
        };
    },
    [SET_WARN_ON_MOBILE_DATA](
        state: ConnectionReduxState,
        {
            payload: { connectionIsCorrect },
        }: ReturnType<typeof setConnectionIsCorrect>,
    ): ConnectionReduxState {
        return {
            ...state,
            warnOnMobileData: connectionIsCorrect,
        };
    },
};

export default { initialState, handlers };
